import React, {useState, useEffect} from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/hooks";
import { selectNews, updateConfig } from "../../../lib/slices/appConfig";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import Api from "../../../lib/Api";

// import "./NewsConfig.css";
import { SourceType } from "../../../lib/models";

export default function NewsConfig() {

    const [showConfig, setShowConfig] = useState(false);
    const [defaultFilter, setDefaultFilter] = useState("");
    const [filters, setFilters] = useState<string[]>([]);
    // const [notifyOnNew, setNotifyOnNew] = useState(false);
    const [selectedSource, setSelectedSource] = useState(-1);

    const [sourceError, setSourceError] = useState("");
    const [defaultFilterError, setDefaultFilterError] = useState("");

    const freeNewsConfigLimit = 4;
    const isPremium = false;

    const news = useAppSelector(selectNews);

    const dispatch = useAppDispatch();

    // useEffect(() => {
    //     console.log("UseEffect", committees);
    // }, [committees])

    function addFilter(event: any) {
        let _filters = [...filters];
        _filters.push("");
        setFilters(_filters);
    }

    function updateFilter(id: number, text: string) {
        let _filters = [...filters];
        _filters[id] = text;
        setFilters(_filters);
    }

    function removeFilter(id: number) {
        let _filters = [...filters];
        _filters.splice(id, 1);
        setFilters(_filters);
    }

    function loadNewsConfig(id: number) {
        setSelectedSource(news[id].SourceType);
        setDefaultFilter(news[id].DefaultFilter);
        setFilters(news[id].NotificationFilters);
    }

    function unloadNewsConfig() {
        setSelectedSource(-1);
        setDefaultFilter("");
        setFilters([]);
    }

    
    async function saveConfig() {
        // let select= (document.getElementById("committee-select") as HTMLInputElement);
        // let id = parseInt(select.value);

        let hasError = false;
        const id = selectedSource;
        console.log(id);
        if (id == -1) {
            setSourceError("La fuente de noticia es requerida.");
            hasError = true;
        }
        else {
            setSourceError("");
        }
        
        let _news = [...news];
        let _filters = [...filters];
        let _defaultFilter = defaultFilter;

        if(defaultFilter == "") {
            setDefaultFilterError("Por lo menos 1 filtro es requerido.");
            hasError = true;
        }
        else {
            setDefaultFilterError("");
        }

        if(hasError)
            return;

        let foundNewsConfig: any;
        let foundIndex = -1;
        news.forEach((elem, i) => {
            if (elem.SourceType == id) {
                foundNewsConfig = elem;
                foundIndex = i;
                return
            }
        });

        const save = async () => {
            if(foundNewsConfig && foundIndex != -1) {
                let updatedNewsConfig = {
                    SourceType: selectedSource,
                    DefaultFilter: _defaultFilter,
                    NotifyOnNewNews: true,
                    NotificationFilters: _filters
                }
                _news[foundIndex] = updatedNewsConfig;
                const configResult = await Api.updateNewsConfig(_news);
                if(!configResult.Error) {
                    const config = configResult.Data;
                    if(config) {
                        dispatch(updateConfig(config));
                    }
                }

                setSourceError("");
                setDefaultFilterError("");
                setDefaultFilter("");
                setSelectedSource(-1);
                setFilters([]);
            }
            else {
                const _newsConfig = {
                    SourceType: selectedSource,
                    DefaultFilter: _defaultFilter,
                    NotifyOnNewNews: true,
                    NotificationFilters: _filters
                }
                _news.push(_newsConfig);
                const configResult = await Api.updateNewsConfig(_news);
                if(!configResult.Error) {
                    const config = configResult.Data;
                    if(config) {
                        dispatch(updateConfig(config));
                    }
                }
                
                setSourceError("");
                setDefaultFilterError("");
                setDefaultFilter("");
                setSelectedSource(-1);
                setFilters([]);
            }
        };

        if(isPremium) {
                await save();
        }
        else {
            if(news.length < freeNewsConfigLimit) {
                await save();
            }
        }
    }

    async function removeNewsConfig(i: number) {
        const _news = [...news];
        _news.splice(i,1);
        const configResult = await Api.updateNewsConfig(_news);
        if(!configResult.Error) {
            const config = configResult.Data;
            if(config) {
                dispatch(updateConfig(config));
            }
        }
    }

    function getSourceName(sourceId: SourceType) {
        switch(sourceId) {
            case SourceType.ENDI:
                return "El Nuevo Día";
            case SourceType.Vocero:
                return "El Vocero";
            case SourceType.Noticel:
                return "Noticel";
        }
    }

    return (
        <>
            <div className='legislation-settings-header-container'>
                <div className='legislation-settings-header-item'  onClick={() => { setShowConfig(!showConfig); unloadNewsConfig(); }}>
                    <div role="button" className="button">Configurar Alertas de Noticias <FontAwesomeIcon icon="gear" /></div>
                </div>
            </div>
            {
                showConfig?                    
                    <div className="legislation-settings-container">
                        <div className="legislation-settings-items-container">
                            <div>
                                <select id="committee-select" value={selectedSource} onChange={(e) => {
                                    setSelectedSource(parseInt(e.target.value));
                                    if(e.target.value != "-1")
                                        setSourceError("");
                                }} className="committee-select">
                                    <option value="-1">Seleccione una Fuente Noticiosa</option>
                                    <option value="1">El Nuevo D&iacute;a</option>
                                    <option value="2">El Vocero</option>
                                    <option value="3">Noticel</option>
                                </select>
                            </div>
                            {sourceError && <div style={{ color: 'red' }}>{sourceError}</div>}
                        </div>
                        <div className="legislation-settings-items-container">
                            <input type="checkbox" disabled checked={true} id="notifyOnNew" />
                            <label htmlFor="notifyOnNew">Recibirás notificaciones sobre noticias nuevas filtradas.</label>
                        </div>
                        <div className="legislation-settings-items-container">
                            <div>
                                <label>Establezca los filtros aplicables a las noticias</label>
                            </div>
                            <div className="sm-form-button" onClick={(e) => addFilter(e)}>
                                A&ntilde;adir Filtro
                            </div>
                        </div>
                        <div className="legislation-settings-items-container">
                            <input type="text" onChange={(e) =>  {
                                setDefaultFilter(e.target.value);
                                if(e.target.value != "")
                                    setDefaultFilterError("");
                            }} className="textbox" value={defaultFilter} name="filters" placeholder="Filtro" />
                        </div>
                        {defaultFilterError && <div style={{ color: 'red' }}>{defaultFilterError}</div>}
                        {
                            filters.map((val, i) => {
                                return (
                                    <div key={`filter_${i}`} className="legislation-settings-items-container">
                                        <input type="text" onChange={(e) => updateFilter(i, e.target.value)} className="textbox" value={val} name="filters" placeholder="Filtro" />
                                        <FontAwesomeIcon icon={faCircleXmark} onClick={() => removeFilter(i)} />
                                    </div>
                                )
                            })
                        }
                        <div className="legislation-settings-items-container">
                            <div className="form-button" onClick={async () => await saveConfig()}>
                                Guardar
                            </div>
                        </div>
                        <br />
                        <div className="selected-committee-container">
                            {
                                news.map((elem, i) => {
                                    return (
                                        <div key={`selected_committee_${i}`} className="selected-committee-item">
                                            <div className={selectedSource == elem.SourceType? "committee-button committee-selected selected-committee-item-active" : "committee-button committee-selected"} onClick={() => loadNewsConfig(i)}>{getSourceName(elem.SourceType)}</div>
                                            <FontAwesomeIcon style={{cursor: "pointer"}} onClick={() => removeNewsConfig(i)} icon={faCircleXmark} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}